/**
 * Deze klasse handelt het tonen van de groepen, met de ll en de instructie, geen edit mogelijkheden, alles floating left ipv scrollers
 *
 * @history
 * 16 juni 2023
 * kopie GroupInit ivm aangepaste implementatie
 *
 */

import React from "react";
import {GroupInstruction} from "../forms/GroupInstruction";
import {GroupLogEntries} from "../logger/GroupLogEntries";

export class GroupShowNoEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                groups_loaded: false,
                groups: [],
                show_group: false,
                show_log_group: false,
                curr_group_index: -1,
            };

        this.loadGroups = this.loadGroups.bind(this);
        this.hideGroup = this.hideGroup.bind(this);

        this.showGroupLogClicked = this.showGroupLogClicked.bind(this);
        this.hideGroupLogClicked = this.hideGroupLogClicked.bind(this);

    }

    hideGroup()
    {
        this.setState({show_group:false})
    }

    hideGroupLogClicked() {
        this.setState(
            {
                show_log_group: false
            }
        )
    }

    showGroupLogClicked(p_index) {
        this.setState(
            {
                show_log_group: true,
                curr_group_index: p_index

            }
        )
    }



    async loadGroups() {
        const formData = new FormData();


        formData.append("access_id1", window.app.logboek.access_id1);
        formData.append("access_id2", window.app.logboek.access_id2);
        formData.append("round", window.app.logboek.getSessionField('current_round'));
        const requestOptions = {
            method: 'POST',
            body: formData
        };

        await fetch("/get_groups", requestOptions)
            .then(response => response.json())
            .then(groups_json => {

                if (groups_json.status == "ok") {
                    console.log( groups_json.data[0]);
                    this.setState({
                        groups: groups_json.data,
                        groups_loaded: true
                    });


                } else {
                    console.log("?");
                }
            });
    }

    componentDidMount() {
        this.loadGroups();

    }

    render() {

        return (

            <div className={"tool__content__groupshow__wrapper"}>



                {!this.state.groups_loaded  && !this.state.show_group &&
                    (
                        <p style={{"text-align": "center", "margin-top": "45vh"}}>Even geduld AUB, alle gegevens worden
                            ingeladen</p>
                    )}


                    {this.state.groups_loaded    && !this.state.show_group &&
                        (
                            <>

                                    {this.state.groups.map((group,group_index) =>


                                                <div className={"tool__content__groupshow__group"}
                                                     style={group.location.has_image == "Y" ? {
                                                         "background-image": "url('" + group.location.image_url + "')",
                                                         "background-size": "contain",
                                                         "background-repeat":"no-repeat",
                                                         "background-position":"bottom"
                                                     } : {}}>
                                                    <div
                                                        className={"tool__content__groupshow__group__label"}> {group.location.title}


                                                        <a href="javascript:void(0)"
                                                           onClick={() => this.setState({show_group:true, curr_group_index: group_index})}><img
                                                            src={"/digibord/assets/svgs/ui/eye_white.svg"}
                                                            className={"ui_icon_small"} style={{float: "right"}}/></a>

                                                        {this.props.show_log &&
                                                            (
                                                                <a href="javascript:void(0)"
                                                                   onClick={() => this.showGroupLogClicked(group_index)}><img
                                                                    src={"/digibord/assets/svgs/ui/logboek_white.svg"}
                                                                    className={"ui_icon_small"}
                                                                    style={{float: "right"}}/></a>

                                                            )}
                                                    </div>



                                                </div>

                                        )
                                    }


                            </>
                        )}


                {this.state.show_group  &&
                    (
                        <GroupInstruction callback={this.hideGroup}
                                   instruction={this.state.groups[this.state.curr_group_index].instruction}
                                   group_id={this.state.groups[this.state.curr_group_index].id}
                                   location={this.state.groups[this.state.curr_group_index].location.title}
                                   has_image={this.state.groups[this.state.curr_group_index].has_image === "Y"}
                                          icons={this.state.groups[this.state.curr_group_index].icons}
                                          has_audio={this.state.groups[this.state.curr_group_index].has_audio === "Y"}
                                   image_url={(this.state.groups[this.state.curr_group_index].has_image === "Y") ? this.state.groups[this.state.curr_group_index].image_url : ""}
                                          audio_url={(this.state.groups[this.state.curr_group_index].has_audio === "Y") ? this.state.groups[this.state.curr_group_index].audio_url : ""}
                                          pupils = {this.state.groups[this.state.curr_group_index].pupils}
                                   />
                    )}


                {this.state.show_log_group &&
                    (
                        <GroupLogEntries group={this.state.groups[this.state.curr_group_index]}
                                         callback={this.hideGroupLogClicked}/>
                    )}

            </div>


        );
    }

}
